window.Vue = require('vue/dist/vue.js')
/*
 *
 */
const EventBus = new Vue({
  data() {
    return {
      channels: [],
    }
  },
  created() {},
})
export default EventBus
